// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c1e4c6e1","977":"fb5cf911"}[chunkId] + ".chunk.js";
};